<template>
  <div id="modal-cids-ciaps">
    <!-- BOTÃO -->
    <slot name="trigger">
      <!-- botão padrão caso não passe slot -->
      <button class="btn btn-open" @click="abrir">Códigos</button>
    </slot>
    <b-modal
      :visible="showModal"
      @hidden="fechar"
      @shown="carregar"
      title="Códigos"
      size="xl"
      hide-footer
      centered
      scrollable
    >
      <div class="ajuda-cids-ciaps">
        <!-- LOADING -->
        <div v-if="loading" class="text-center my-4">
          <b-spinner label="Carregando"></b-spinner>
          <div class="mt-2 small text-muted">Carregando…</div>
        </div>

        <!-- ERRO -->
        <div v-else-if="error" class="alert alert-danger mb-0">
          {{ error }}
        </div>

        <!-- CONTEÚDO -->
        <div v-else>
          <b-tabs class="esus-feedback-tabs tabs-auto" content-class="mt-3">
            <b-tab title="CIAP" active>
              <div class="my-4">
                <b-form-checkbox-group
                  v-model="filtroPeriodoSelecionado"
                  :options="opcoesFiltroPeriodo"
                  value-field="value"
                  text-field="label"
                />
              </div>
              <v-app class="app-tabela">
                <div class="box mt-0 mb-0">
                  <v-card class="tabela">
                    <v-card-title>
                      <v-text-field
                        v-model="searchCiaps"
                        append-icon="mdi-magnify"
                        label="Buscar código ou descrição"
                        class="input-bottom"
                        single-line
                        hide-details
                      />
                    </v-card-title>

                    <v-data-table
                      :headers="headersCiaps"
                      :items="indexedItemsCiapsFiltrados"
                      :loading="loading"
                      loading-text="Carregando, Por favor espere"
                      :search="searchCiaps"
                      :footer-props="{
                        itemsPerPageText: '',
                        'items-per-page-options': [10],
                        'disable-items-per-page': true,
                      }"
                      item-key="index"
                      class="elevation-1"
                    >
                      <template v-slot:[`footer.page-text`]="items">
                        <div class="info-table-item tabela-esus-pec"></div>
                        <span class="paginacao">
                          {{ items.pageStart }} - {{ items.pageStop }} de
                          {{ items.itemsLength }} registros
                        </span>
                      </template>

                      <template v-slot:expanded-item="{ headers }">
                        <td :colspan="headers.length"></td>
                      </template>

                      <template v-slot:progress>
                        <v-progress-linear
                          color="blue"
                          :height="10"
                          indeterminate
                        />
                      </template>

                      <template v-slot:no-data>
                        <div class="alert alert-info mb-0">
                          <b
                            >Nenhuma informação encontrada. Selecione outro
                            filtro.</b
                          >
                        </div>
                      </template>

                      <template v-slot:no-results>
                        <div class="alert alert-info mb-0">
                          <b
                            >Nenhuma informação encontrada. Selecione outro
                            filtro.</b
                          >
                        </div>
                      </template>
                    </v-data-table>
                  </v-card>
                </div>
              </v-app>
            </b-tab>

            <b-tab title="CID">
              <div class="my-4">
                <b-form-checkbox-group
                  v-model="filtroPeriodoSelecionado"
                  :options="opcoesFiltroPeriodo"
                  value-field="value"
                  text-field="label"
                />
              </div>
              <v-app class="app-tabela">
                <div class="box mt-0 mb-0">
                  <v-card class="tabela">
                    <v-card-title>
                      <v-text-field
                        v-model="searchCids"
                        append-icon="mdi-magnify"
                        label="Buscar código ou descrição"
                        class="input-bottom"
                        single-line
                        hide-details
                      />
                    </v-card-title>

                    <v-data-table
                      :headers="headersCids"
                      :items="indexedItemsCidsFiltrados"
                      :loading="loading"
                      loading-text="Carregando, Por favor espere"
                      :search="searchCids"
                      :footer-props="{
                        itemsPerPageText: '',
                        'items-per-page-options': [10],
                        'disable-items-per-page': true,
                      }"
                      item-key="index"
                      class="elevation-1"
                    >
                      <template v-slot:[`footer.page-text`]="items">
                        <div class="info-table-item tabela-esus-pec"></div>
                        <span class="paginacao">
                          {{ items.pageStart }} - {{ items.pageStop }} de
                          {{ items.itemsLength }} registros
                        </span>
                      </template>

                      <template v-slot:expanded-item="{ headers }">
                        <td :colspan="headers.length"></td>
                      </template>

                      <template v-slot:progress>
                        <v-progress-linear
                          color="blue"
                          :height="10"
                          indeterminate
                        />
                      </template>

                      <template v-slot:no-data>
                        <div class="alert alert-info mb-0">
                          <b
                            >Nenhuma informação encontrada. Selecione outro
                            filtro.</b
                          >
                        </div>
                      </template>

                      <template v-slot:no-results>
                        <div class="alert alert-info mb-0">
                          <b
                            >Nenhuma informação encontrada. Selecione outro
                            filtro.</b
                          >
                        </div>
                      </template>
                    </v-data-table>
                  </v-card>
                </div>
              </v-app>
            </b-tab>
            <b-tab title="SIGTAP">
              <div class="my-4">
                <b-form-checkbox-group
                  v-model="filtroPeriodoSelecionado"
                  :options="opcoesFiltroPeriodo"
                  value-field="value"
                  text-field="label"
                />
              </div>

              <v-app class="app-tabela">
                <div class="box mt-0 mb-0">
                  <v-card class="tabela">
                    <v-card-title>
                      <v-text-field
                        v-model="searchSigtap"
                        append-icon="mdi-magnify"
                        label="Buscar código ou descrição"
                        class="input-bottom"
                        single-line
                        hide-details
                      />
                    </v-card-title>

                    <v-data-table
                      :headers="headersSigtap"
                      :items="indexedItemsSigtapFiltrados"
                      :loading="loading"
                      :search="searchSigtap"
                      :footer-props="{
                        itemsPerPageText: '',
                        'items-per-page-options': [10],
                        'disable-items-per-page': true,
                      }"
                      item-key="index"
                      class="elevation-1"
                    >
                      <template v-slot:[`footer.page-text`]="items">
                        <div class="info-table-item tabela-esus-pec"></div>
                        <span class="paginacao">
                          {{ items.pageStart }} - {{ items.pageStop }} de
                          {{ items.itemsLength }} registros
                        </span>
                      </template>

                      <template v-slot:expanded-item="{ headers }">
                        <td :colspan="headers.length"></td>
                      </template>

                      <template v-slot:progress>
                        <v-progress-linear
                          color="blue"
                          :height="10"
                          indeterminate
                        />
                      </template>

                      <template v-slot:no-data>
                        <div class="alert alert-info mb-0">
                          <b
                            >Nenhuma informação encontrada. Selecione outro
                            filtro.</b
                          >
                        </div>
                      </template>

                      <template v-slot:no-results>
                        <div class="alert alert-info mb-0">
                          <b
                            >Nenhuma informação encontrada. Selecione outro
                            filtro.</b
                          >
                        </div>
                      </template>
                    </v-data-table>
                  </v-card>
                </div>
              </v-app>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'ModalAjudaCidsCiaps',
  props: {
    grupoFiltro: {
      type: Array,
      default: () => [],
    },
    ciap: {
      type: Array,
      default: () => [],
    },
    cid: {
      type: Array,
      default: () => [],
    },
    sigtap: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showModal: false,
      loading: false,
      error: null,
      itemsCiaps: [],
      searchCiaps: '',
      headersCiaps: [
        { text: 'Código', align: 'start', filterable: true, value: 'codigo' },
        {
          text: 'Descrição',
          align: 'start',
          filterable: true,
          value: 'nome',
        },
      ],
      itemsCids: [],
      searchCids: '',
      headersCids: [
        { text: 'Código', align: 'start', filterable: true, value: 'codigo' },
        {
          text: 'Descrição',
          align: 'start',
          filterable: true,
          value: 'nome',
        },
      ],
      itemsSigtap: [],
      searchSigtap: '',
      headersSigtap: [
        { text: 'Código', value: 'codigo' },
        { text: 'Descrição', value: 'nome' },
      ],
      filtroPeriodoSelecionado: ['gravidez'],
      opcoesFiltroPeriodo: [
        { label: 'Gravidez', value: 'gravidez' },
        { label: 'Parto', value: 'parto' },
        { label: 'Aborto', value: 'aborto' },
      ],
    }
  },
  computed: {
    indexedItemsCiapsFiltrados() {
      return this.itemsCiaps
        .filter((it) => this.itemPassaNoFiltroPeriodo(it))
        .map((it, idx) => ({
          index: idx,
          ...it,
        }))
    },

    indexedItemsCidsFiltrados() {
      return this.itemsCids
        .filter((it) => this.itemPassaNoFiltroPeriodo(it))
        .map((it, idx) => ({
          index: idx,
          ...it,
        }))
    },

    indexedItemsSigtapFiltrados() {
      return this.itemsSigtap
        .filter((it) => this.itemPassaNoFiltroPeriodo(it))
        .map((it, idx) => ({
          index: idx,
          ...it,
        }))
    },
  },
  methods: {
    /**
     * Abre o modal
     */
    abrir() {
      this.showModal = true
    },

    /**
     * Fecha o modal
     */
    fechar() {
      this.showModal = false
    },

    /**
     * Verifica quais dados exibir de acordo com o grupo
     * @param {string} idGrupo
     */
    grupoPassaNoFiltro(idGrupo) {
      // Se o array vier vazio - aceita todos os grupos
      if (this.grupoFiltro.length === 0) return true

      // Se tiver valores - aceita apenas os que estiverem no array
      return this.grupoFiltro.includes(idGrupo)
    },

    /**
     * Verifica se o item pertence ao grupo
     * @param {object} item
     */
    itemPassaNoFiltroPeriodo(item) {
      const grupo = String(item.id_grupo || '').toLowerCase()

      // Se nenhum selecionado retorna tudo
      if (!this.filtroPeriodoSelecionado.length) return true

      // Se algum selecionado precisa bater com o grupo
      return this.filtroPeriodoSelecionado.includes(grupo)
    },

    /**
     * Retorna os dados dos CIDS / CIAPS
     */
    async carregar() {
      this.loading = true
      this.error = null

      this.itemsCiaps = []
      this.itemsCids = []
      this.itemsSigtap = []

      try {
        const response = await this.$api.post(
          `/app/utils/cids-ciaps-sigtap/${this.$store.state.cod_ibge}`,
          {
            ciap: this.ciap,
            cid: this.cid,
            sigtap: this.sigtap,
          }
        )

        const lista = response.data || []

        lista.forEach((item) => {
          if (!this.grupoPassaNoFiltro(item.id_grupo)) return

          const registro = {
            id_grupo: item.id_grupo,
            codigo: item.codigo,
            nome: item.nome,
          }

          if (item.tp_cod === 'CIAP') {
            this.itemsCiaps.push(registro)
          }

          if (item.tp_cod === 'CID') {
            this.itemsCids.push(registro)
          }

          if (item.tp_cod === 'SIGTAP') {
            this.itemsSigtap.push(registro)
          }
        })
      } catch (e) {
        console.error(e)
        this.error = 'Não foi possível carregar os dados.'
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
#modal-cids-ciaps .btn-open {
  text-transform: initial;
}

.ajuda-cids-ciaps code {
  font-size: 0.8rem;
}
</style>
